import { useCurrentLocale } from "../../i18n/useCurrentLocale";
import {
    FALLBACK_REGION,
    isCountryCodeSupported,
    supportedCountries,
} from "./supportedCountries";
import type { Region, SupportedCountryCode } from "./types";

export function useCurrentCountryCodeForCurrentLocale():
    | SupportedCountryCode
    | undefined {
    const { locale, localeIsFallbackLocale } = useCurrentLocale();

    return localeIsFallbackLocale || !isCountryCodeSupported(locale.region)
        ? undefined
        : locale.region;
}

export function useRegionForCurrentLocale(): Region {
    const countryCode = useCurrentCountryCodeForCurrentLocale();

    return countryCode ? supportedCountries[countryCode] : FALLBACK_REGION;
}
